import apiClient from 'lib/apiClient';

export const getArticle = (type, brand) => {
  return apiClient
    .get('API/1_0/article.php', {
      params: {
        article_type: type,
        article_brand: brand,
      },
    })
    .then((r) => {
      return r[0];
    });
};

export const saveUserArticle = (data) =>
  apiClient.post('API/1_0/userArticle.php', data);
